/**
 * AUTH57 Slice C — register Travel static shell SW in production builds only.
 * Never registers during Jest / CRA start (NODE_ENV !== 'production').
 * Scope is Travel origin root (/); does not control Member/Admin hosts.
 */

import {
  TRAVEL_SW_SCRIPT_URL,
} from './offlineSwPolicy';

/**
 * @returns {{ registered: boolean, reason?: string, registration?: Promise<unknown> }}
 */
export function registerTravelServiceWorker() {
  if (typeof process !== 'undefined' && process.env.NODE_ENV !== 'production') {
    return { registered: false, reason: 'non-production' };
  }

  if (typeof window === 'undefined') {
    return { registered: false, reason: 'no-window' };
  }

  if (!('serviceWorker' in navigator)) {
    return { registered: false, reason: 'unsupported' };
  }

  const registrationPromise = new Promise((resolve) => {
    const run = () => {
      navigator.serviceWorker
        .register(TRAVEL_SW_SCRIPT_URL, { scope: '/', updateViaCache: 'none' })
        .then((registration) => resolve({ ok: true, registration }))
        .catch((error) => {
          // SW failure must not break online Travel bootstrap.
          if (typeof console !== 'undefined' && console.warn) {
            console.warn('[travel-sw] registration failed', error && error.message ? error.message : 'unknown');
          }
          resolve({ ok: false, error });
        });
    };

    if (document.readyState === 'complete') {
      run();
    } else {
      window.addEventListener('load', run, { once: true });
    }
  });

  return { registered: true, registration: registrationPromise };
}

/** Test helper — does not touch navigator. */
export function shouldRegisterTravelServiceWorker(env = process.env.NODE_ENV) {
  return env === 'production';
}
